import renderComponent from './render_component'

window.renderComponent = renderComponent
